import { render, staticRenderFns } from "./HrSalaryCalcGjjDetail.vue?vue&type=template&id=7c242dfa&scoped=true&"
import script from "./HrSalaryCalcGjjDetail.vue?vue&type=script&lang=js&"
export * from "./HrSalaryCalcGjjDetail.vue?vue&type=script&lang=js&"
import style0 from "./HrSalaryCalcGjjDetail.vue?vue&type=style&index=0&id=7c242dfa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c242dfa",
  null
  
)

export default component.exports